'use client';

import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

import {
  type CountdownState,
  resolveCountdownState,
} from '../_utils/countdown';

/**
 * 다음 가능 시각(서버 권위, epoch ms)까지 1초 단위 카운트다운 상태를 파생한다.
 * 대기 중일 때만 인터벌을 돌리고, 가능해지면(도달하면) 인터벌을 멈춘다.
 */
export const useCountdown = (
  nextAvailableAtMs: number | null,
): CountdownState => {
  const [nowMs, setNowMs] = useState(() => dayjs().valueOf());
  const state = resolveCountdownState({ nowMs, nextAvailableAtMs });

  useEffect(() => {
    if (state.isAvailable) {
      return;
    }

    const intervalId = setInterval(() => setNowMs(dayjs().valueOf()), 1000);

    return () => clearInterval(intervalId);
  }, [state.isAvailable]);

  return state;
};
